/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { docsCatalogControllerCatalog } from "./docsCatalogControllerCatalog";
import { docsCatalogControllerContent } from "./docsCatalogControllerContent";
import { documentsControllerCreate } from "./documentsControllerCreate";
import { documentsControllerFetchFile } from "./documentsControllerFetchFile";
import { documentsControllerFindAll } from "./documentsControllerFindAll";
import { documentsControllerFindAllProcessing } from "./documentsControllerFindAllProcessing";
import { documentsControllerFindAllProcessingJobs } from "./documentsControllerFindAllProcessingJobs";
import { documentsControllerFindAllSteps } from "./documentsControllerFindAllSteps";
import { documentsControllerFindOne } from "./documentsControllerFindOne";
import { documentsControllerFindOneProcessing } from "./documentsControllerFindOneProcessing";
import { documentsControllerFindOneStep } from "./documentsControllerFindOneStep";
import { documentsControllerGetDownloadUrl } from "./documentsControllerGetDownloadUrl";
import { documentsControllerGetVersionHistory } from "./documentsControllerGetVersionHistory";
import { documentsControllerRemove } from "./documentsControllerRemove";
import { documentsControllerUpdate } from "./documentsControllerUpdate";

export function documentsService() {
  return { documentsControllerCreate, documentsControllerFindAll, documentsControllerFindOne, documentsControllerUpdate, documentsControllerRemove, documentsControllerGetVersionHistory, documentsControllerFetchFile, documentsControllerFindAllProcessing, documentsControllerFindOneProcessing, documentsControllerFindAllSteps, documentsControllerFindOneStep, documentsControllerFindAllProcessingJobs, documentsControllerGetDownloadUrl, docsCatalogControllerCatalog, docsCatalogControllerContent }
}